<template>
    <div class="aboveTable">
        <div class="top">
            <h1 class="heading">{{ heading }}</h1>
        </div>
        <div class="inner flex flex-wrap justify-between items-center">
            <div class="left">
                <Filters
                    v-if="filters"
                    :filters="filters"
                    :active="activeFilter"
                    @changed="val => $emit('filterChanged', val)"
                />
            </div>
            <div class="right flex">
                <div
                    v-if="showSearch"
                    class="searchHolder"
                >
                    <SearchField
                        v-model="newSearch"
                        @keydown.enter.native="$emit('search', newSearch)"
                    />
                </div>
                <AppButton
                    v-if="createLink"
                    :url="createLink"
                    label="Create new"
                >
                    <template v-slot:icon>
                        <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>
                    </template>
                </AppButton>
            </div>
        </div>
    </div>
</template>

<script>
import AppButton from '../ui/AppButton.vue';
import Filters from '../ui/Filters.vue';
import SearchField from '../ui/SearchField.vue';

export default {
    components: {
        AppButton,
        SearchField,
        Filters,
    },
    props: {
        heading: {
            type: String,
            default: null,
        },
        showSearch: {
            type: Boolean,
            default: true,
        },
        createLink: {
            type: String,
            default: null,
        },
        filters: {
            type: Array,
            default: null,
        },
        activeFilter: {
            type: String,
            default: null,
        },
        currentSearch: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        newSearch: null,
    }),
    watch: {
        $route() {
            if (this.$route.query.search) {
                this.newSearch = this.$route.query.search;
            } else {
                this.newSearch = null;
            }
        },
    },
    mounted() {
        if (this.$route.query.search) {
            this.newSearch = this.$route.query.search;
            this.$emit('search', this.newSearch);
        }
    },
};
</script>

<style lang="postcss" scoped>
.aboveTable,
.top {
    margin-bottom: 25px;
}
.searchHolder {
    width: 330px;
    padding-right: 25px;
    @media (--laptop) {
        width: 280px;
    }
}
</style>
